<template>
  <section>
    <h1 class="text-2xl font-bold tracking-tight text-slate-900 mb-4">
      User Account List
    </h1>
    <div class="container mx-auto p-2 sm:p-4 lg:p-6 bg-white rounded-lg">
      <div class="px-0 sm:px-0 lg:px-0">
        <div class="sm:flex flex-col sm:items-left px-4">
          <nav class="mb-4 flex justify-end" aria-label="breadcrumb">
            <div class="w-58 pr-3" v-if="activeUserType !== 3">
              <select
                class="form-select mt-1 block w-full border-1 border-borderColor rounded-lg p-2 focus:outline-none bg-white"
                v-model="dateRangeFilter"
              >
                <option value="">Select {{ activeUserType === 2 ? 'Earnings' : 'Spent' }} Date Range</option>
                <option value="1">1 day</option>
                <option value="7">7 days</option>
                <option value="15">15 days</option>
                <option value="30">30 days</option>
              </select>
            </div>
            <div class="w-44">
              <select
                class="form-select mt-1 block w-full border-1 border-borderColor rounded-lg p-2 focus:outline-none bg-white"
                v-model="activeUserType"
              >
                <option :value="3">All Users</option>
                <option :value="2">Trainers</option>
                <option :value="1">Attendees Only</option>
              </select>
            </div>
          </nav>
          <div class="relative text-gray-700 w-full">
            <input
              class="w-full h-10 pl-8 pr-3 text-base placeholder-gray-600 border-1 rounded-lg focus:outline-none"
              type="text"
              placeholder="Search By Name or Email"
              v-model.lazy="search"
            />
            <div
              class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="mt-2 container mx-auto px-2 py-1 sm:p-2 lg:p-4 bg-white rounded-lg">
          <AdminTableLayout
            :tableheader="getActiveUserheader"
            :tableData="getActiveUserTableData"
            :tablePaginateInfo="pagination"
            :tableFunctions="getTableFuncRefs"
            :tableFlags="getActiveTableFlags"
          ></AdminTableLayout>
        </div>
      </div>
    </div>
    <Modal
      :title="'Confirmation'" v-model="toggleConfirm"
      :handleClose="closeModalHandler"
    >
      <div class="rediret-warn flex flex-col items-center justify-end">
        <p>
          {{ modalQuery['text'] }}
        </p>
        <div class="flex items-center justify-end w-full pt-6">
          <button 
            @click="confirmModalHandler"
            class="h-8 px-2 float-right text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"> 
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import { PaginationComponent, Modal } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import AdminTableLayout from '@/views/admin/AdminTableLayout.vue'
import moment from 'moment-timezone'
import Vue from 'vue';

export default {
  name: "AdminUsers",
  components: {
    PaginationComponent,
    AdminTableLayout,
    Modal
  },
  data() {
    return {
      activeUserType: 3,
      attendeeHeader: [
        { name: "First Name", sort: 'default', keyName: 'f_name' },
        { name: "Last Name", sort: 'default', keyName: 'l_name' },
        { name: "Account Created Date", sort: 'default', keyName: 'account_created_time' },
        { name: "Last Active", sort: 'default', keyName: 'last_login' },
        { name: "Email", sort: 'default', keyName: 'email' },
        { name: "Amount Spend (USD)", sort: 'default', keyName: 'amount_spent' },
        { name: "Booked Classes", sort: 'default', keyName: 'total_booked_sessions' },
        { name: "Booked Courses", sort: 'default', keyName: 'total_booked_courses' },
        { name: "Status", sort: false, keyName: 'is_active' },
        { name: "Time to join", sort: false, keyName: 'time_to_join' }
      ],
      trainerHeader: [
        { name: "First Name", sort: 'default', keyName: 'f_name' },
        { name: "Last Name", sort: 'default', keyName: 'l_name' },
        { name: "Account Created Date", sort: 'default', keyName: 'account_created_time' },
        { name: "Last Active", sort: 'default', keyName: 'last_login' },
        { name: "Email", sort: 'default', keyName: 'email' },
        { name: "Amount Earned (USD)", sort: 'default', keyName: 'amount_earned' },
        { name: "Booked Classes", sort: 'default', keyName: 'total_booked_sessions' },
        { name: "Booked Courses", sort: 'default', keyName: 'total_booked_courses' },
        { name: "Status", sort: false, keyName: 'is_active' },
        { name: "Platform Fee", sort: false, keyName: 'platform_fee_exception' }
      ],
      items: [],
      items_init: [],
      current_page: 1,
      last_page: 1,
      search: null,
      toggleConfirm: false,
      selectedUserObj: null,
      modalQuery: {
        text: null,
        operation: null
      },
      sortParams: null,
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0
      },
      dateRangeFilter: ''
    };
  },
  watch: {
    search() {
      this.sortParams = null
      this.resetSortMappingHandler({keyName: ''})
      this.dateRangeFilter = ''
      this.handleGetAdminUsers();
    },
    activeUserType () {
      this.sortParams = null
      this.resetSortMappingHandler({keyName: ''})
      this.search = null
      this.dateRangeFilter = ''
      this.handleGetAdminUsers({page: 1});
    },
    dateRangeFilter () {
      this.handleGetAdminUsers({page: 1, ...this.sortParams})
    }
  },
  computed: {
    ...mapGetters(["adminUsers"]),
    getActiveUserheader () {
      return this.activeUserType === 2 ? this.trainerHeader : this.attendeeHeader
    },
    getActiveUserTableData () {
      return this.items
    },
    getActiveTableFlags () {
      return {
        activeUserType: this.activeUserType
      }
    },
    getTableFuncRefs () {
      return {
        activateSortHandler: this.activateSortHandler,
        toggleUserStatusHandler: this.toggleUserStatusHandler,
        toggleUserTimeHandler: this.toggleUserTimeHandler,
        handlePageChange: this.handlePageChange,
        toggleTrainerFeesHandler: this.toggleTrainerFeesHandler
      }
    },
    getDateRangeFilter () {
      let toDate = new Date();
      let fromDate = new Date();
      fromDate.setDate(toDate.getDate() - this.dateRangeFilter);
      return {
        from: moment(fromDate).format('YYYY-MM-DD'),
        to: moment(toDate).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    ...mapActions(["getAdminUsers"]),
    setUserTypeHandler (type) {
      this.activeUserType = type
    },
    async handlePageChange(page) {
      await this.handleGetAdminUsers({page: page, ...this.sortParams})
    },
    async handleGetAdminUsers(payloadQuery) {
      let query = {
        search: this.search,
        ...payloadQuery
      };
      this.activeUserType ? query.user_type = this.activeUserType : ''
      this.dateRangeFilter ? query = {...query, ...this.getDateRangeFilter} : ''
      await this.getAdminUsers({ query });
      this.items_init = this.adminUsers.data;
      if (this.activeUserType === 2) {
        this.items = this.items_init.map((obj) => ({
          ...obj,
          platform_fee_exception_boolean: Boolean(obj.platform_fee_exception),
          init_fee_state: Boolean(obj.platform_fee_exception),
          init_is_active_state: !Boolean(obj.is_active),
          is_active_boolean: !Boolean(obj.is_active)
        }));
      } else {
        this.items = this.items_init.map((obj) => ({
          ...obj,
          time_to_join_boolean: Boolean(obj.time_to_join),
          init_time_state: Boolean(obj.time_to_join),
          init_is_active_state: !Boolean(obj.is_active),
          is_active_boolean: !Boolean(obj.is_active)
        }));
      }
      this.pagination.current_page = this.adminUsers.current_page
      this.pagination.last_page = this.adminUsers.last_page
      this.pagination.total = this.adminUsers.total
    },
    toggleModalHandler () {
      this.toggleConfirm = !this.toggleConfirm
    },
    toggleUserTimeHandler (dataObj) {
      this.selectedUserObj = dataObj
      this.modalQuery['text'] = 'Are you sure you want to toggle Time to join for the user?'
      this.modalQuery['operation'] = 'time'
      this.toggleModalHandler()
    },
    toggleTrainerFeesHandler (dataObj) {
      this.selectedUserObj = dataObj
      this.modalQuery['text'] = 'Are you sure you want to toggle the platform fees for the trainer?'
      this.modalQuery['operation'] = 'fees'
      this.toggleModalHandler()
    },
    toggleUserStatusHandler (dataObj) {
      this.selectedUserObj = dataObj
      const flagText = dataObj.is_active ? 'In-Active' : 'Active'
      this.modalQuery['text'] = `Are you sure you want to mark user ${flagText}  on the platform?`
      this.modalQuery['operation'] = 'activeStatus'
      this.toggleModalHandler()
    },
    confirmModalHandler () {
      if (this.modalQuery['operation'] && this.modalQuery['operation'] === 'time') {
        this.platformTimeHandler()
      } else if (this.modalQuery['operation'] && this.modalQuery['operation'] === 'fees') {
        this.platformFeesHandler()
      } else {
        this.userStatusChangeHandler()
      }
    },
    closeModalHandler () {
      this.toggleModalHandler()
      this.activeUserType === 2 ? this.revertTrainerToggleHandler() : this.revertToggleHandler()
    },
    revertToggleHandler () {
      let newObj = {}
      if (this.modalQuery['operation'] && this.modalQuery['operation'] === 'time') {
        newObj = {
          ...this.selectedUserObj,
          time_to_join_boolean: this.selectedUserObj.init_time_state
        }
      } else {
        newObj = {
          ...this.selectedUserObj,
          is_active_boolean: this.selectedUserObj.init_is_active_state
        }
      }
      const index = this.items.indexOf(this.selectedUserObj)
      Vue.set(this.items, index, newObj)
    },
    revertTrainerToggleHandler () {
      let newObj = {}
      if (this.modalQuery['operation'] && this.modalQuery['operation'] === 'fees') {
        newObj = {
          ...this.selectedUserObj,
          platform_fee_exception_boolean: this.selectedUserObj.init_fee_state
        }
      } else {
        newObj = {
          ...this.selectedUserObj,
          is_active_boolean: this.selectedUserObj.init_is_active_state
        }
      }
      const index = this.items.indexOf(this.selectedUserObj)
      Vue.set(this.items, index, newObj)
    },
    async platformTimeHandler () {
      this.toggleModalHandler()
      await this.$store.dispatch('updateAdminUserTimeToJoin', this.selectedUserObj.id).then((res) => {
        if (res && res.data) {
          const newObj = {
            ...this.selectedUserObj,
            time_to_join_boolean: Boolean(res.data.time_to_join),
            init_time_state: Boolean(res.data.time_to_join)
           }
          const index = this.items.indexOf(this.selectedUserObj)
          Vue.set(this.items, index, newObj)
          this.$store.commit("setIsSuccess", res && res.message);
        }
      }).catch((err) => {
        this.revertToggleHandler()
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
    },
    async userStatusChangeHandler () {
      this.toggleModalHandler()
      await this.$store.dispatch('updateUserStatus', this.selectedUserObj).then((res) => {
        if (res && res.data) {
          const newObj = {
            ...this.selectedUserObj,
            init_is_active_state: !Boolean(res.data.is_active),
            is_active_boolean: !Boolean(res.data.is_active),
            is_active: res.data.is_active
           }
          const index = this.items.indexOf(this.selectedUserObj)
          Vue.set(this.items, index, newObj)
          this.$store.commit("setIsSuccess", res && res.message);
        }
      }).catch((err) => {
        this.revertToggleHandler()
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
    },
    async platformFeesHandler () {
      this.toggleModalHandler()
      await this.$store.dispatch('updateAdminTrainerPlatformFees', this.selectedUserObj.id).then((res) => {
        if (res && res.data) {
          const newObj = {
            ...this.selectedUserObj,
            platform_fee_exception_boolean: Boolean(res.data.platform_fee_exception),
            init_fee_state: Boolean(res.data.platform_fee_exception)
           }
          const index = this.items.indexOf(this.selectedUserObj)
          Vue.set(this.items, index, newObj)
          this.$store.commit("setIsSuccess", res && res.message);
        }
      }).catch((err) => {
        this.revertToggleHandler()
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
    },
    activateSortHandler (obj) {
      this.sortParams = {
        sort: obj.keyName
      }
      if(obj && obj.sort && obj.sort === 'default') {
        this.sortParams.sort_order = 'desc'
        obj.sort = 'desc'
      } else if (obj && obj.sort && obj.sort === 'desc') {
        this.sortParams.sort_order = 'asc'
        obj.sort = 'asc'
      } else if (obj && obj.sort && obj.sort === 'asc') {
        this.sortParams.sort_order = 'desc'
        obj.sort = 'desc'
      }
      this.resetSortMappingHandler(obj)
      this.handleGetAdminUsers(this.sortParams)
    },
    resetSortMappingHandler (obj) {
      this.getActiveUserheader && this.getActiveUserheader.map((itm) => {
        itm.keyName === obj.keyName ? '' : itm.sort ? itm.sort = 'default' : ''
        return itm
      })
    }
  },
  async created() {
    this.handleGetAdminUsers({page: this.current_page});
  },
};
</script>